// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W5UjoESiajc7c6uwWzOj{grid-template-rows:auto 1fr;display:grid}.W5UjoESiajc7c6uwWzOj.zgRpNZ4MEkDhDE4q5xS3{grid-template-rows:1fr;padding-top:16px}.VD5RFwyFWcjvlC4yaYJe{align-items:center;height:54px;margin:0 -2px;display:flex}.fypTF07Vq6gkhrcMSC7r{padding:5px 0}.qkyoaksLY3EOmxDarHCY{padding:50px 0}.dYv5ctPVBaUHFx8rMARi{color:var(--content-primary-tertiary);justify-content:center;padding:17.5px 12px;display:flex}.mzXcJ7ekDeYZ0FC6RSLE{padding:37.5px 12px 17.5px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `W5UjoESiajc7c6uwWzOj`,
	"hideTabs": `zgRpNZ4MEkDhDE4q5xS3`,
	"tabs": `VD5RFwyFWcjvlC4yaYJe`,
	"loadingMore": `fypTF07Vq6gkhrcMSC7r`,
	"loading": `qkyoaksLY3EOmxDarHCY`,
	"empty": `dYv5ctPVBaUHFx8rMARi`,
	"empty--all": `mzXcJ7ekDeYZ0FC6RSLE`,
	"emptyAll": `mzXcJ7ekDeYZ0FC6RSLE`
};
export default ___CSS_LOADER_EXPORT___;
